import { defineStyle } from '@chakra-ui/react';

export const calendarVariant = defineStyle({
  height: '44px',
  width: '44px',
  border: '2px solid',
  backgroundColor: 'neutral.black',
  color: 'neutral.800',
  _hover: {
    borderColor: 'skyBlue',
    backgroundColor: 'neutral.800',
    color: 'neutral.200',
  },
  '&[data-active=true]': {
    border: '0',
    backgroundColor: 'blue',
    color: 'neutral.white',
  },
});
